<template>
  <div class="costContainer">
    <div class="headerCon">
      <div class="left"><van-icon name="arrow-left" @click="$router.replace('/insuranceHome');" /></div>
      <div class="headerTit">商保填报信息查询</div>
      <div class="right">
      </div>
    </div>
    <div class="selectCon">

      <el-select v-model="policyStatus" placeholder="请选择查询关联投保状态" size="medium" @change="changePolicyStatus" clearable>
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="keywords" placeholder="请输入要查询的信息" prefix-icon="el-icon-search" size="medium"
        @change="changePolicyStatus" clearable></el-input>
    </div>
    <div class="costContent">
      <el-table :data="tableData" style="width: 100%" border :header-cell-style="{ background: '#F7F9FA' }"
        :max-height="windowHeight" v-loading="loading">
        <el-table-column prop="empno" label="工号" align="center" width="80">
        </el-table-column>
        <el-table-column prop="employeeName" label="姓名" align="center" width="80">
        </el-table-column>
        <!-- <el-table-column prop="relationType" align="center" label="关联投保关系" width="80">
        </el-table-column> -->
        <el-table-column prop="childName" align="center" label="关联投保姓名" width="80">
        </el-table-column>
        <el-table-column prop="isInsured" align="center" label="是否为子女参保" width="80">
        </el-table-column>
        <el-table-column prop="gender" align="center" label="投保子女性别" width="80">
        </el-table-column>
        <el-table-column prop="idType" align="left" label="关联投保证件类型" width="90" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="idNumber" align="center" label="关联投保证件号" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="birthDate" align="center" label="投保子女出生日期" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="isMarried" align="center" label="投保子女婚否" width="80">
        </el-table-column>
        <el-table-column prop="isStudent" align="center" label="投保子女是否在校生" width="90">
        </el-table-column>
        <el-table-column prop="schoolCity" align="center" label="投保子女学校城市" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="schoolName" align="center" label="投保子女学校名称" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="paymentType" align="center" label="付费类型" width="80">
        </el-table-column>
        <el-table-column prop="startDate" align="center" label="保单生效时间" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="endDate" align="center" label="保单失效时间" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="active" align="center" label="在职状态" width="80">
        </el-table-column>
        <el-table-column prop="policyStatus" align="center" label="关联投保信息状态" width="80">
        </el-table-column>
        <el-table-column prop="declareTime" align="center" label="最后变更日期" width="80" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div class="pageContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageData.page" :page-sizes="[10, 20, 50, 80, 100]" :page-size="pageData.pageSize"
          layout="total, prev, pager, next,sizes" :total="total">
        </el-pagination>
      </div>
      <div class="footerBtn">
        <div class="btnCon">
          <div v-loading="exportBtnLoading" class="btn exportBtn" @click="hanleExport"><img
              src="@/assets/insurance/daochu.png" alt="">商保填报导出</div>

          <!-- <el-upload class="upload-demo" :on-change="handleChange" :on-remove="handleRemove" :auto-upload="false"
            :file-list="fileList" action="#">
          </el-upload> -->
          <div class="btn importBtn" @click="handleImport"><img src="@/assets/insurance/daoru.png" alt="">保单信息导入</div>

        </div>
      </div>
    </div>
    <Export ref="exportDialog" :downloadTitle="downloadTitle" :querInfo="querInfo"></Export>
  </div>
</template>

<script>
import apis from "@/apis/insurance.js";
// import moment from "moment";
import "moment/locale/zh-cn";
import Export from "./exportFile.vue";
import moment from 'moment';
export default {
  name: "commercialFillPC",
  components: {
    Export
  },
  data() {
    return {
      options: [
        {
          label: '新建',
          value: '新建'
        },
        {
          label: '变更',
          value: '变更'
        },
        {
          label: '正常',
          value: '正常'
        },
        {
          label: '失效',
          value: '失效'
        },
        {
          label: '未关联',
          value: '未关联'
        },
      ],
      policyStatus: '',
      keywords: '',
      tableData: [],
      upload: "",
      file: "",
      formDataPage: "",
      fileList: [],
      downloadTitle: "商保填报导出模板",
      childrenNameList: [],
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      windowHeight: '700',
      loading: false,
      exportBtnLoading: false
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.querInfo();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.windowHeight = window.innerHeight - 295;
    },
    //搜索
    changePolicyStatus() {
      this.querInfo();
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.querInfo1();
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.querInfo1();
    },
    //获取 商保填报信息查询 列表
    querInfo() {
      this.pageData = {
        page: 1,
        pageSize: 20
      };
      const json = {
        // empno: JSON.parse(localStorage.getItem("store")).userInfo.userid,
        keywords: this.keywords,
        policyStatus: this.policyStatus,
        ...this.pageData
      };
      this.loading = true;
      apis.queryEmployeeChild(json).then(res => {
        if (res.code == "200") {
          this.tableData = res.data.map(item => {
            item.declareTime = item.declareTime ? moment(item.declareTime).format('YYYY-MM-DD') : null;
            item.birthDate = item.birthDate ? moment(item.birthDate).format('YYYY-MM-DD') : null;
            item.active = item.active == 0 ? '在职' : item.active == 5 ? '离职' : '';
            item.isInsured = item.isInsured == 1 ? '是' : item.isInsured == 0 ? '否' : '';
            item.isMarried = item.isMarried == 1 ? '是' : item.isMarried == 0 ? '否' : '';
            item.isStudent = item.isStudent == 1 ? '是' : item.isStudent == 0 ? '否' : '';
            item.gender = item.gender == 1 ? '男' : item.gender == 2 ? '女' : '';
            return item;
          });
          this.total = res.total;
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    //获取 商保填报信息查询 列表
    querInfo1() {
      const json = {
        // empno: JSON.parse(localStorage.getItem("store")).userInfo.userid,
        keywords: this.keywords,
        policyStatus: this.policyStatus,
        ...this.pageData
      };
      this.loading = true;
      apis.queryEmployeeChild(json).then(res => {
        if (res.code == "200") {
          this.tableData = res.data.map(item => {
            item.declareTime = item.declareTime ? moment(item.declareTime).format('YYYY-MM-DD') : null;
            item.birthDate = item.birthDate ? moment(item.birthDate).format('YYYY-MM-DD') : null;
            item.active = item.active == 0 ? '在职' : item.active == 5 ? '离职' : '';
            item.isInsured = item.isInsured == 1 ? '是' : item.isInsured == 0 ? '否' : '';
            item.isMarried = item.isMarried == 1 ? '是' : item.isMarried == 0 ? '否' : '';
            item.isStudent = item.isStudent == 1 ? '是' : item.isStudent == 0 ? '否' : '';
            item.gender = item.gender == 1 ? '男' : item.gender == 2 ? '女' : '';
            return item;
          });
          this.total = res.total;
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    //导出
    hanleExport() {
      const json = {
        // empno: JSON.parse(localStorage.getItem("store")).userInfo.userid,
        ...this.pageData
      };
      this.exportBtnLoading = true;
      apis.exportEmployeeChild(json).then(res => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `员工子女.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.exportBtnLoading = false;
      }).catch(() => {
        this.exportBtnLoading = false;
      });
    },
    //上传文件
    handleChange(file) {
      this.fileList = [file];
    },
    // 删除文件
    handleRemove() {
      this.fileList = [];
    },
    // 取消上传
    cancelBtn() {
      this.fileList = [];
      this.dialogVisible = false;
      this.step = 1;
    },
    //显示上传弹窗
    handleImport() {
      this.$refs.exportDialog.dialogVisible = true;
      // const json = {

      // };
      // apis.importPolicy(json).then(res => {
      //   if (res.code === 200) {
      //     this.step = 2;
      //     this.$message({
      //       message: "导入成功",
      //       type: "success"
      //     });
      //   }
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

::v-deep {
  .el-table .cell.el-tooltip {
    width: 100% !important;
  }
}

.costContainer {
  width: 100%;
  padding-top: 20px 60px;

  background-color: #fff;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 15px 30px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282B32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .selectCon {
    // height: 112px;
    background-color: #fff;
    margin-bottom: 20px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-content: center !important;
    flex-wrap: wrap-reverse;

    .el-input {
      width: 680px;
      margin-top: 20px;
    }

    .el-select {
      width: 340px;
      margin-top: 20px;
    }
  }

  .costContent {
    height: calc(100vh - 228px);
    overflow-y: auto;
    padding-bottom: 20px;
    background-color: #fff;
  }

  .footerBtn {
    background-color: #fff;
    padding: 15px 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin-top: 80px;

    .btnCon {
      display: flex;
      align-content: center;

      .btn {
        display: flex;
        align-items: center;
        width: 312px;
        font-size: 32px;
        border-radius: 8px;
        padding: 20px 30px;
        text-align: center;
        margin-right: 40px;
        border: 1px solid #4ea27c;

        img {
          width: 34px;
          height: 38px;
          margin-right: 20px;
        }
      }

      .exportBtn {
        background-color: #fff;
        color: #4ea27c;
      }

      .importBtn {
        background-color: #4ea27c;
        color: #fff;
      }
    }

    ::v-deep(.van-button--small) {
      width: 310px;
      height: 88px;
      border-radius: 10px;
      font-size: 27px;
      border: 0;
      margin-right: 60px;
    }
  }

  .pageContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
}
</style>
